angular
    .module("skillBuilderSaaS")
    .filter("yesNo", function () {
    return function (input) {
        return input ? "common.yes" : "common.no";
    };
});
